import { formatDocumentCategory } from 'src/lib/formatters'

// Short description of the filter narrowing the list the preview steps through,
// shown as a chip in the preview header. Undefined when nothing is filtered.
export const buildPreviewFilterLabel = ({
  searchTerm,
  categories,
}: {
  searchTerm?: string
  categories?: string[]
}): string | undefined => {
  const parts: string[] = []
  if (searchTerm) parts.push(`Search: "${searchTerm}"`)
  if (categories?.length === 1) {
    parts.push(`Category: ${formatDocumentCategory(categories[0] as never)}`)
  } else if (categories?.length > 1) {
    parts.push(`${categories.length} categories`)
  }
  return parts.length > 0 ? parts.join(' · ') : undefined
}

// The table page (1-based) holding the document at `index` of the full list.
export const pageContainingIndex = (index: number, limit: number): number =>
  Math.floor(index / limit) + 1
